/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

const confirm = createAction('bookingCard/confirm');
const reject = createAction('bookingCard/reject');
const cancel = createAction('bookingCard/cancel');
const setStatus = createAction('bookingCard/setStatus');

export { confirm, reject, cancel, setStatus };
